module.exports = __webpack_public_path__ + "static/media/leclerc2.08b37c98.jpg";